import React from 'react';
import styles from './AnalysisBanner.module.css';
import { formatDate } from '@/utils/formatDate';

interface AnalysisBannerProps {
  analysisName: string;
  createdAt: string;
}

export const AnalysisBanner: React.FC<AnalysisBannerProps> = ({
  analysisName,
  createdAt
}) => {
  return (
    <div className={styles.banner}>
      <div className={styles.bannerContent}>
        <span className={styles.analysisName}>
          <i
            className="pi pi-chart-line"
            style={{ marginRight: 6, fontSize: '0.9rem' }}
          />
          {analysisName}
        </span>
        <span className={styles.createdDate}>
          Created {formatDate(createdAt)}
        </span>
      </div>
    </div>
  );
};
